import { createRootRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { AppShell } from '@/components/app-shell'
import { AUTH_FAILED_EVENT } from '@/api/client'

function RootRoute() {
  const navigate = useNavigate()
  useEffect(() => {
    const handler = () => {
      toast.error('Authentication failed', {
        description: 'Add or refresh your bearer token in Settings.',
      })
      void navigate({ to: '/settings' })
    }
    window.addEventListener(AUTH_FAILED_EVENT, handler)
    return () => window.removeEventListener(AUTH_FAILED_EVENT, handler)
  }, [navigate])
  return <AppShell />
}

export const Route = createRootRoute({
  component: RootRoute,
})
